import { usePageTitleTranslation } from 'libs/navigation';

import { useTimezoneSettings } from '../hooks/useTimezoneSettings';
import { TimezoneSettingsView } from '../views/TimezoneSettingsView';

export const TimezoneSettingsContainer = () => {
  const { timezones, initialValues, loading, submitLoading, onSubmit } =
    useTimezoneSettings();

  usePageTitleTranslation('settings.title');

  return (
    <TimezoneSettingsView
      initialValues={initialValues}
      loading={loading}
      submitLoading={submitLoading}
      timezones={timezones || []}
      onSubmit={onSubmit}
    />
  );
};
